module.exports = __webpack_public_path__ + "img/pen-icon-gray.ede353b7.svg";